/**
 * Conversation mode
 */
export enum ConversationMode {
    VOICE = 'VOICE',
    KEYBOARD = 'KEYBOARD',
}
